// Hash-based routing. Lane B may swap to react-router; for now this is
// dependency-free and aligned with how the existing OMS routes.

export function parseHash() {
  const raw = window.location.hash.replace(/^#/, '') || '/';
  // strip query (e.g. ?addChildOf=T901) so route matching stays clean
  const h = raw.split('?')[0];
  const parts = h.split('/').filter(Boolean);
  return { path: '/' + parts.join('/'), parts };
}

export function navigate(to) {
  window.location.hash = to;
}
